import {Paper, styled} from "@mui/material";

export const MonthlyLimitsContainer = styled(Paper)(() => {
    return {
        padding: '1rem',
    }
});

export const CustomerPageEmpty = styled('div')(() => {
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '15rem',
        width: '100%'
    }
});

